import Color from '@bubble-dev/fantasy-color';
import { createConstantColor } from './helpers';
export var brandLollipopKlarnaPink = createConstantColor(new Color('#FFB3C7'));
export var brandLollipopKlarnaBlack = createConstantColor(new Color('#17120F'));
export var brandLollipopKlarnaWhite = createConstantColor(new Color('#FFFFFF'));
export var brandLollipopSmooothYellow = createConstantColor(new Color('#FFF673'));
export var brandLollipopSmooothYellowBlocks = createConstantColor(new Color('#FFF999'));
export var brandLollipopSmooothGreen = createConstantColor(new Color('#80FFA6'));
export var brandLollipopSmooothGreenBlocks = createConstantColor(new Color('#9EFFBB'));
export var brandLollipopSmooothBlue = createConstantColor(new Color('#73F5FF'));
export var brandLollipopSmooothBlueBlocks = createConstantColor(new Color('#99F8FF'));
export var brandLollipopVanilla = createConstantColor(new Color('#FFFAB0'));
export var brandLollipopVanillaLight = createConstantColor(new Color('#FFFCC9'));
export var brandLollipopMint = createConstantColor(new Color('#B8FFCC'));
export var brandLollipopMintLight = createConstantColor(new Color('#D1FFE0'));
export var brandLollipopPool = createConstantColor(new Color('#B3F9FF'));
export var brandLollipopPoolLight = createConstantColor(new Color('#CCFCFF'));
export var brandLollipopLavender = createConstantColor(new Color('#E9D6FF'));
export var brandLollipopLavenderLight = createConstantColor(new Color('#F0E3FF'));
export var brandLollipopSky = createConstantColor(new Color('#BDD5FF'));
export var brandLollipopSkyLight = createConstantColor(new Color('#D1E2FF'));
export var brandLollipopPeach = createConstantColor(new Color('#FFD7AD'));
export var brandLollipopPeachLight = createConstantColor(new Color('#FFE6CC'));
//# sourceMappingURL=lollipopBrandColors.js.map